import { UnknownAction } from "redux";
import IAction from "../models/IAction";

/**
 * Type guard to check if an action is an IAction
 */
export function isIAction<T>(action: unknown): action is IAction<T> {
  return typeof action === "object" && action !== null && "type" in action && typeof (action as any).type === "string";
}

/**
 * Convert IAction to UnknownAction for Redux 5 compatibility
 */
export function toUnknownAction<T>(action: IAction<T>): UnknownAction {
  return action as UnknownAction;
}

/**
 * Helper to create actions compatible with Redux 5
 */
export function createAction<T>(type: string, payload?: T, error?: boolean, meta?: any): UnknownAction {
  const action: IAction<T> & UnknownAction = {
    type,
    ...(payload !== undefined && { payload }),
    ...(error !== undefined && { error }),
    ...(meta !== undefined && { meta }),
  } as any;

  return action;
}
